import { axiosClient } from "services/axios";

export function deleteEmployeesGroup(usersgroupid: string) {
  return axiosClient.delete("users/user-group", { params: { usersgroupid } });
}
